<template>
  <section class="detail-panel-box">
    <header>
      <strong>{{ title }}</strong>
      <slot name="header" />
    </header>
    <slot></slot>
    <br>
    <footer>
      <slot name="footer" />
    </footer>
  </section>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      panelClass: "panel"
    };
  }
};
</script>
<style lang="scss" scoped>
.detail-panel-box {
  header {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: 800;
    color: #1b1b1b;
    background: #f1f1f1;
    padding-left: 0;
    margin: 15px 0;
    > div {
      display: inline-block;
      font-weight: 400;
      >div{
         display: inline-block;
      }
    }
  }
  &+.detail-panel-box{
    margin-top: 40px;;
  }
  &:last-child{
    margin-bottom: 40px;
  }

}
</style>
<style lang="scss">
.detail-panel-box {
  .el-row {
    .el-input,
    .el-select,
    .el-date-editor {
      width: 270px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// details-panel.vue?74a1942a